import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { CompetenciesService } from 'src/app/services/competencies.service';
import { config } from '../../../_models/userCompetency'
import { UtilityService } from '../../../services/utility.service'
import { DeleteConfirmModalComponent } from '../../../commons/delete-confirm-modal/delete-confirm-modal.component';
import { FileQueueObject, FileUploaderService } from '../../../services/file-uploader.service';
import * as _ from 'lodash'
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-add-comp-modal',
  templateUrl: './add-comp-modal.component.html',
  styleUrls: ['./add-comp-modal.component.scss']
})
export class AddCompModalComponent implements OnInit {
  categoryTitle = []
  recertificateDate
  comp
  expiryDate;
  type
  slectedCategory;
  isReset
  category = config.list
  compForm
  newFiles: any = []
  instructorId
  compFiles = []
  deleteFile = []
  isEdit
  isAdd
  deletedFiles: any = [];
  currentTypeId
  minDate
  queue: Observable<FileQueueObject[]>;
  enableSave: boolean;
  categoryTitleCopy: any = [];
  isError: boolean = false
  titleChange
  isSubmit: false
  loading: Boolean = false;
  errorMsg: boolean = false

  /**
   * create delete file varible  
   */


  constructor(
    public dialogRef: MatDialogRef<AddCompModalComponent>,
    public formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _competencyService: CompetenciesService,
    public uploader: FileUploaderService,
    public _filter: FilterService,
  ) {
    // this.dialogRef.disableClose = false
  }

  ngOnInit() {
    console.log("this current data check !!1", this.data)
    this.instructorId = this.data.instructorId

    if (this.data.isEdit) {
      this.isEdit = true

      this.compFiles = this.data.competency.competenciesType[this.data.competency.competenciesType.length - 1].files
      this.currentTypeId = this.data.competency.competenciesType[this.data.competency.competenciesType.length - 1]._id
      this.type = this.data.competency.competenciesType[this.data.competency.competenciesType.length - 1].type
      let element = this.category.find((x) => x.viewValue === this.data.competency.category)
      console.log("this is last element to be select", element);
      if (element != undefined) {
        this.categoryTitle = element.value
        this.categoryTitleCopy = element.value
        // this.compFiles = element.files
      }
    } else {
      this.isAdd = true
    }
    this.createForm(this.data.competency)


    this.queue = this.uploader.queue;
    this.queue.subscribe(res => {
      console.log("%c SOMETHING CHANGED IN QUEUE=====>>>>>", "color:red", res);
      if (res.length == 0) {
        this.enableSave = true
      }
      else {
        this.enableSave = false
      }
    })

  }


  // FORM CONTROL

  /**
   * 
     create Form Group Using Form Control  

     when edit form whem pass data in data perameter and intilize form other blank ''
     */

  createForm(data?) {
    this.type
    this.compForm = this.formBuilder.group({
      alias: new FormControl(((data && data.alias) ? data.alias : '', Validators.required)),
      type: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].type : '', Validators.required),
      category: new FormControl((data && data.category) ? data.category : '', Validators.required),
      title: new FormControl((data && data.title) ? data.title : '', Validators.required),
      achievementDate: new FormControl((data && data.achievementDate) ? data.achievementDate : '', Validators.required),
      assessmentDate: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].assessmentDate : null),
      recertificationDate: new FormControl((data && data.recertificationDate) ? data.recertificationDate : ''),
      trainingBook: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].trainingBook : ''),
      assessmentComplete: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].assessmentComplete : ''),
      bookedBy: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].bookedBy : ''),
      bookedDate: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].bookedDate : ''),
    })

  }



  // UTILITY



  cancle() {
    this.dialogRef.close()
  }




  /**
   * Select category value using find  Array element of Json Static Array
   * intilize Element Value on title Varible
  */

  selectCategory(event) {

    let element = this.category.find((x) => x.viewValue === event.value)
    console.log("this is last element to be select", element);
    if (element.viewValue == 'others') {
      this.compForm.patchValue({ type: 'interim' })
      this.compForm.patchValue({ alias: 'other' })
    }
    if (element != undefined) {
      this.categoryTitle = element.value
      this.categoryTitleCopy = element.value
    }
    console.log("this.categoryTitle", this.categoryTitle);

  }


  /**
   * 
   Selected Title Value Using Find categoryTitle Array element
  
   element type and alias patch form 
   */
  selectTitle(event?) {
    console.log("what is the value of edit", this.isEdit);
    // if (!this.isEdit) {
    console.log("this is for add");

    let title = this.compForm.value.title
    let element = this.categoryTitle.find((x) => x.name === title)
    if (element != undefined) {
      this.type = element.compType
      this.compForm.patchValue({ type: element.compType })
      this.compForm.patchValue({ alias: element.alias })
      if (this.isEdit) this.onChangedEvent(this.compForm.value.achievementDate, 'achievementDate'), this.errorMsg = true
    }
    // } else {
    // let title = this.compForm.value.title
    // let element = this.categoryTitle.find((x) => x.name === title)
    // console.log("this is for edit", element);
    // if (element != undefined) {
    // this.type = element.compType
    // this.compForm.patchValue({ type: element.compType })
    // this.compForm.patchValue({ alias: element.alias })

    // }
    // }
    // this.compForm.patchValue({ title:})
  }


  /**
   * 
   * assessment check box checked when call this event 
   * 
   * here title add base on assessment complete checkbox checked, unchecked
   * 
   * 
   */


  assessmentCompleteChanges(event) {
    console.log("what is the category list", this.categoryTitle);
    if (event.checked == true) {
      if (this.compForm.controls['category'].value != 'others') {


        this.isError = true
        let temptitle = this.categoryTitle.filter((x) => x.alias == this.data.competency.alias)
        console.log("temp title here ==>", temptitle)
        console.log("what is the type", this.type);
        if (this.type == 'probationary') {
          let title = temptitle.find((x) => x.compType == 'interim')
          this.titleChange = title.name
          // this.compForm.patchValue({ title: title.name })
        }
      }
    } else {
      this.isError = false
      // let temptitle = this.categoryTitle.find((x) => x.alias == this.data.competency.alias && x.compType == this.type)
      if (this.type == 'interim') this.compForm.patchValue({ assessmentDate: '' })
      // this.compForm.patchValue({ title: temptitle.name })
    }
    console.log("value of form after change", this.compForm.value);


  }


  /**
   * Onchanged Event is date component emit event 
   * 
   * achivement date is event return date value patch
   * 
   * caculation of assessment date
   *     form control title value and type using find element 
   *     element valid  month add in ahivement date and caculate
   *     assementdate
   * 
   * 
   * caculate recertificate date
   *    form control title value and type using find element 
   *    
   *    type probationary
   *          when use valid for month intrim type element
   *     
   * bookdate 
   *      event default value patch
   *  
   * 
   * Assement compeleted flag checked 
   * 
   * when select manually assement date     
   */



  onChangedEvent(event, formControl) {
    // console.log("call this", event, formControl);

    let categoryValue = this.compForm.controls['category'].value

    let tempDate = new Date(event)
    console.log("single tempdate", tempDate);

    let finalDate = tempDate.setDate(tempDate.getDate() + 1)
    console.log("selected categoryvalue", categoryValue);
    if (categoryValue == 'others') {
      // console.log("what is final date", new Date(finalDate), tempDate.setDate(tempDate.getDate() + 1));
      if (formControl == 'achievementDate') this.compForm.patchValue({ achievementDate: event }), this.minDate = new Date(finalDate)
      if (formControl == 'recertificationDate') this.compForm.patchValue({ recertificationDate: event })
      if (formControl == 'bookedDate') this.compForm.patchValue({ bookedDate: event })
      if (formControl == 'assessmentDate') this.compForm.patchValue({ assessmentDate: event })
      console.log("this is for type others", event);


    } else {
      if (formControl == 'achievementDate') {
        let achievementDate = event
        // let tempDate = new Date(event)

        // let finalDate = tempDate.setDate(tempDate.getDate() + 1)
        console.log("single tempdate", tempDate);
        this.minDate = new Date(finalDate)
        this.compForm.patchValue({ achievementDate: achievementDate })

        const element = this.categoryTitle.find((x) => x.alias === this.compForm.value.alias && x.compType == this.type)
        console.log("this is element", element);

        if (this.type == 'probationary') {

          const date = new Date(achievementDate)
          const month = Number(element.validFor)
          let assessmentDate = new Date(date.setMonth(date.getMonth() + month));
          let assessmentDate1 = ((assessmentDate.getMonth() > 8) ? (assessmentDate.getMonth() + 1) : ('0' + (assessmentDate.getMonth() + 1))) + '/' + ((assessmentDate.getDate() > 9) ? assessmentDate.getDate() : ('0' + assessmentDate.getDate())) + '/' + assessmentDate.getFullYear()
          this.compForm.patchValue({ assessmentDate: assessmentDate1 })
        }
        else {
          this.compForm.patchValue({ assessmentDate: '' })
        }

        const elementForRecertificate = this.categoryTitle.find((x) => x.alias == this.compForm.value.alias && x.compType == 'interim')
        console.log("recertitificate Date here ==>", elementForRecertificate)

        const date1 = new Date(achievementDate)
        const month1 = Number(elementForRecertificate.validFor)
        let recertificationDate = new Date(date1.setMonth(date1.getMonth() + month1));
        let recertificationDate1 = ((recertificationDate.getMonth() > 8) ? (recertificationDate.getMonth() + 1) : ('0' + (recertificationDate.getMonth() + 1))) + '/' + ((recertificationDate.getDate() > 9) ? recertificationDate.getDate() : ('0' + recertificationDate.getDate())) + '/' + recertificationDate.getFullYear()

        this.compForm.patchValue({ recertificationDate: recertificationDate1 })

      }
      else if (formControl == 'bookedDate') {
        this.compForm.patchValue({ bookedDate: event })
      }
      else if (formControl == 'assessmentDate') {
        console.log("call this part or not");

        this.compForm.patchValue({ assessmentDate: event })

      }
      else if (formControl == 'recertificationDate') {
        this.compForm.patchValue({ recertificationDate: event })
      }
      console.log("data value", this.compForm.value)
    }
  }


  deletedFile(event) {
    console.log("when file is deleted", event);
    let element = this.deletedFiles.findIndex((x) => x.typeId == this.currentTypeId)

    if (element == -1) {
      let obj = {
        typeId: this.currentTypeId,
        files: [event._id]
      }
      this.deletedFiles.push(obj)
    } else {
      this.deletedFiles[element].files.push(event._id)
    }


    console.log('this.deletedFiles', this.deletedFiles)
    let index = _.findIndex(this.compFiles, function (o) { return o._id == event._id })
    if (index > -1) {
      // this.files[index]['isDeleted'] = true;
      this.compFiles.splice(index, 1)
    }
    console.log("this is the deleted files arry");

  }


  /**
   * 
   * new-file-model use html side and emit event name competenciesFiles
   * here get reponse of all s3 uploaded file arrays 
   */
  competenciesFiles(event) {
    console.log("here is the file of competencies ===>", event)
    let obj = {
      typeId: this.currentTypeId,
      files: [...event.files]
    }
    this.newFiles.push(obj)
    this.enableSave = true
    console.log("this is the new file data", this.newFiles);

  }

  onKey(searchText) {
    console.log("event", searchText);
    // this.afterFilter = null
    // this.filterActive = true;
    this.categoryTitle = this.categoryTitleCopy
    if (searchText === '') {
      console.log('FILTER CALLED', searchText);
      // this.filterActive = false;
      // this.updateData(this.jobs);
      this.categoryTitle = this.categoryTitleCopy
      return;
    }
    let data = this.categoryTitle
    console.log("what is the data", data);
    let tempDataSource = this._filter.filter1(searchText, data, ['name', 'alias']);
    console.log("what is the temp data source", tempDataSource);
    if (tempDataSource && tempDataSource.length) this.categoryTitle = tempDataSource
    else this.categoryTitle = tempDataSource
  }



  // API CALL



  /**
   * here call api for add competencies 
   * and initilize file and instructor id
   */

  saveCompetency() {
    this.compForm.value['newFiles'] = this.newFiles
    this.compForm.value['instructorId'] = this.instructorId
    this.compForm.value['deletedFiles'] = this.deletedFiles
    console.log("this.compForm..................", this.compForm, this.compForm.value);
    // if (!this.compForm.invalid) {
    // console.log("check data...........................", this.compForm.value, this.compForm.value.type === "probationary" && (!this.compForm.invalid && (this.compForm.value.assessmentDate !== null)));

    if (this.isEdit) {
      this.compForm.value['competenciesId'] = this.data.competency._id
      this.compForm.value['competenciesType'] = this.data.competency.competenciesType
      this.compForm.value['titleChange'] = this.titleChange
      // this.compForm.value['instructorId'] = this.data.comp.instructor
      console.log("competency Data ==>", this.compForm.value)

      /**
       * update competency pass new upload file 
       * 
       */

      this._competencyService.updateCompetency(this.compForm.value).subscribe((res) => {
        console.log("hello here is the ===>", res)
        this.loading = false;
        // let data = { competency: res.competencies, isEdit: true }
        this._utilityService.handleSnackBar({ msg: "Competency updated successfully!", button: "OK" })
        this.dialogRef.close(res)
      }, (error) => {
        this.loading = false;
        console.log("error message", error)
      })
    }
    else {
      console.log("final form value", this.compForm.value);
      this.loading = true;
      this._competencyService.addCompetency(this.compForm.value).subscribe((res) => {
        this.loading = false;
        console.log("competency Response Here ==>", res)
        this._utilityService.handleSnackBar({ msg: "Competency Added successfully!", button: "OK" })
        this.dialogRef.close(res)
      }, (error) => {
        this.loading = false;
        console.log("error message", error)
      })
    }
    // }
    // else {
    //   this.compForm.markAllAsTouched();
    //   return;
    // }
  }


  /**
   * delete comptencies Api call using CompetenciesId
   */

  deleteCompetencies() {

    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, 'competency').afterClosed().subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        let obj = {
          competencyId: this.data.competency._id,
          instructor: this.data.competency.instructor
        }
        this._competencyService.deleteCompetency(JSON.stringify(obj)).subscribe(res => {
          console.log("Here is competencies delete reponse ==>", res)
          this._utilityService.handleSnackBar({ msg: "Competency Delete successfully!", button: "OK" })
          this.dialogRef.close(res)
        })
      }
    })
  }
  /**
   * delete file emit method call
   * pass perameter index and id,
   * specific index splice file,
   * id push deletefile array, 
   */



}
